import { Button } from "@/components/ui/button";

interface FallbackProps {
  error: unknown;
  resetError: () => void;
}

export function ErrorBoundaryFallback({ error, resetError }: FallbackProps) {
  const message =
    error instanceof Error ? error.message : "Something went wrong.";
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="max-w-md w-full text-center space-y-4">
        <p className="section-tag text-coral">Unexpected error</p>
        <h1 className="font-display text-3xl">Something broke on this page.</h1>
        <p className="text-sm text-muted-foreground break-words">{message}</p>
        <div className="flex gap-2 justify-center">
          <Button onClick={resetError} variant="default">
            Try again
          </Button>
          <Button
            onClick={() => {
              window.location.href = "/";
            }}
            variant="outline"
          >
            Go home
          </Button>
        </div>
      </div>
    </div>
  );
}
